/**
 * Botão "Apontamentos do dia": baixa o que foi registrado hoje no Mapa em
 * PDF, Excel ou CSV, para o PPCP levar as datas para a planilha.
 */
import React from "react";
import ExportMenu from "../../components/ExportMenu";
import { useToast } from "../../context/ToastContext";
import { listarEventosSetor } from "../../services/mapaProducao";
import { formatarDataLocal } from "../../utils/dinheiro";
import {
  COLUNAS_APONTAMENTOS,
  LIMITE_DE_EVENTOS,
  inicioDoDia,
  linhasDosApontamentos,
  podeTerFaltado,
} from "./dados/apontamentos";

export default function ExportarApontamentos({ request, catalogo, hoje, rotulo = "Apontamentos do dia" }) {
  const toast = useToast();

  async function exportar(formato) {
    try {
      const eventos = await listarEventosSetor(request, { desde: inicioDoDia(hoje), limite: LIMITE_DE_EVENTOS });
      const rows = linhasDosApontamentos(eventos || [], (id) => catalogo.nome(id));
      if (rows.length === 0) {
        toast.info("Nenhum apontamento registrado hoje.");
        return;
      }
      if (podeTerFaltado(eventos)) {
        toast.warning(`Hoje passou de ${LIMITE_DE_EVENTOS} registros: a exportação traz só os mais recentes.`);
      }
      // Import tardio: jsPDF/xlsx pesam e só entram quando alguém exporta.
      const { salvarCSV, salvarExcel, salvarPDF } = await import("../../utils/exportacao");
      const opts = {
        titulo: `Apontamentos do dia ${formatarDataLocal(hoje.toISOString())}`,
        secoes: [{ id: "apontamentos", label: "Apontamentos", columns: [...COLUNAS_APONTAMENTOS], rows }],
      };
      if (formato === "csv") salvarCSV(opts);
      else if (formato === "pdf") salvarPDF(opts);
      else salvarExcel(opts);
    } catch (err) {
      toast.error(err?.message || "Falha ao exportar os apontamentos.");
    }
  }

  return <ExportMenu label={rotulo} onExport={exportar} />;
}
